import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgCheckCircleGradient = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 28,
	height: 28,
	viewBox: "0 0 28 28",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M14 28C21.732 28 28 21.732 28 14C28 6.26801 21.732 0 14 0C6.26801 0 0 6.26801 0 14C0 21.732 6.26801 28 14 28Z",
			fill: "url(#paint0_linear_22125_11795)"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M8.16797 15.1667L11.668 18.6667L19.8346 10.5",
			stroke: "white",
			strokeWidth: 2,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsxs("linearGradient", {
			id: "paint0_linear_22125_11795",
			x1: 31.1111,
			y1: -3.11111,
			x2: -1.31135,
			y2: -5.26975,
			gradientUnits: "userSpaceOnUse",
			children: [/* @__PURE__ */ _jsx("stop", { stopColor: "#6785FC" }), /* @__PURE__ */ _jsx("stop", {
				offset: 1,
				stopColor: "#77CDFF"
			})]
		}) })
	]
});
export default SvgCheckCircleGradient;
